import * as React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { GetString } from '../../components/StringResourceManager';

// Constants
import { APP_TITLE } from '../../utils/constants';

export default function Config() {
  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_CONFIG')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_CONFIG')} />
    </>
  );
}
